module.exports = __webpack_public_path__ + "img/restaurant-cover.4b3d066c.jpg";